export class AzureDiskTarget {
    'region';
    'resourceGroupName';
    'settings';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroupName",
            "baseName": "resourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "settings",
            "baseName": "settings",
            "type": "AzureDiskSettings",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureDiskTarget.attributeTypeMap;
    }
    constructor() {
    }
}
